import toastr from '@/lib/notifications';
import $ from "jquery";
import _ from "underscore";
import axios from "axios";
import store from "../state/store";
import { updateLocation, getQueryStringHash } from "../nav";

const switchEnquiryTab = (enquiry_id, tab = "activity") => {
  const currentSearch = getQueryStringHash();
  const sameEnquiry = String(currentSearch.e) === String(enquiry_id);
  const preserved_lpt = sameEnquiry ? currentSearch.lpt : null;
  currentSearch.e = enquiry_id;
  currentSearch.t = tab;
  delete currentSearch.l;
  if (preserved_lpt) {
    currentSearch.lpt = preserved_lpt;
  } else {
    delete currentSearch.lpt;
  }
  updateLocation({ search: currentSearch });

  store.get().ui.enquiry.set({
    id: enquiry_id,
    tab_key: tab,
    lesson_plan_tab: preserved_lpt || 'lesson_setup',
    buttons: {
      support_handover: {
        open: false,
      },
      deactivate: {
        open: false,
      },
      reactivate: {
        open: false,
      },
    },
  });
};

store.on("enquiries:show", function (enquiry_id, tab = "activity") {
  const shown_enquiry = store.get().enquiry;

  if (!shown_enquiry || String(shown_enquiry.id) !== String(enquiry_id)) {
    store.emit("ui:docked_panels:close_addressed");
  }

  store.get().set({
    tutor_results: [],
    tutor_proposals: [],
  });

  return axios
    .get(`/api/sales/enquiries/${enquiry_id}`)
    .then(function (response) {
      const { data } = response;
      const state = store.get();
      state.set({ enquiry: data, lead: null });

      switchEnquiryTab(enquiry_id, tab);

      const first_lesson_plan =
        _.first(
          _.select(data.lesson_plans, function (lesson_plan) {
            return `lp${lesson_plan.id}` === tab;
          }),
        ) || _.first(data.lesson_plans);

      if (first_lesson_plan) {
        store.get().ui.enquiry.set({ lesson_plan_id: first_lesson_plan.id });
        store
          .get()
          .set({
            tutor_proposals: first_lesson_plan.tutoring_job.tutor_proposals,
          });

        if (tab === "tutors") {
          store.emit(
            "tutoring_job:tutor_results:index",
            first_lesson_plan.tutoring_job_id,
          );
        }

        const lesson_plan_tab = store.get().ui.enquiry.lesson_plan_tab;
        if (lesson_plan_tab === 'tutors') {
          store.emit("tutoring_job:tutor_results:index", first_lesson_plan.tutoring_job_id);
        } else if (lesson_plan_tab === 'lesson_pricing') {
          store.emit("lesson_plan:lesson_orders:index", first_lesson_plan.id);
        } else if (lesson_plan_tab === 'placement') {
          store.emit("tutoring_jobs:show", first_lesson_plan.tutoring_job.id);
        }
      }
    })
    .catch((error) => handleError(error));
});

store.on("enquiry:claim", function (enquiry_id) {
  $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/claim`,
    type: "PUT",
    dataType: "json",
    contentType: "application/json",
    success: (data) => {
      store.emit("enquiries:show", enquiry_id);
      store.emit("backlog_items:index", { filter: "my_tasks" });
    },
    error: (data) => {
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("enquiry:deactivate", function (enquiry_id, params = {}) {
  store.get().ui.set({ deactivating_enquiry: true });

  return $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/deactivate`,
    type: "PUT",
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(params),
    success: (data) => {
      store.get().ui.set({ deactivating_enquiry: false });
      store.get().set({ enquiry: data });

      store.emit("backlog_items:show", {
        item_id: enquiry_id,
        item_type: "Sales::Enquiry",
      });

      store.emit("backlog_items:index", { filter: "my_tasks" });
      switchEnquiryTab(enquiry_id, "activity");
    },
    error: (data) => {
      store.get().ui.set({ deactivating_enquiry: false });
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("enquiry:reactivate", function (enquiry_id) {
  $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/reactivate`,
    type: "PUT",
    dataType: "json",
    contentType: "application/json",
    success: (data) => {
      store.get().set({ enquiry: data });

      store.emit("backlog_items:show", {
        item_id: enquiry_id,
        item_type: "Sales::Enquiry",
      });

      store.emit("backlog_items:index", { filter: "my_tasks" });
    },
    error: (data) => {
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("enquiry:handover", function (enquiry_id, params = {}) {
  store.get().ui.set({ handing_over_enquiry: true });

  return $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/handover`,
    type: "PUT",
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(params),
    success: (data) => {
      store.get().ui.set({ handing_over_enquiry: false });
      store.get().set({ enquiry: data });

      store.emit("backlog_items:show", {
        item_id: enquiry_id,
        item_type: "Sales::Enquiry",
      });

      store.emit("users:current");
      store.emit("backlog_items:index", { filter: "my_tasks" });
      switchEnquiryTab(enquiry_id, "activity");
    },
    error: (data) => {
      store.get().ui.set({ handing_over_enquiry: false });
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("enquiry:automatic_track:enable", function (enquiry_id) {
  $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/enable_automatic_track`,
    type: "PUT",
    dataType: "json",
    contentType: "application/json",
    success: (data) => {
      store.get().set({ enquiry: data });
    },
    error: (data) => {
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("enquiry:automatic_track:disable", function (enquiry_id) {
  $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/disable_automatic_track`,
    type: "PUT",
    dataType: "json",
    contentType: "application/json",
    success: (data) => {
      store.get().set({ enquiry: data });
    },
    error: (data) => {
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on(
  "enquiry:workflow_state:update",
  function (enquiry_id, workflow_state) {
    $.ajax({
      url: `/api/sales/enquiries/${enquiry_id}/update_workflow_state`,
      type: "PUT",
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ workflow_state }),
      success: (data) => {
        store.get().set({ enquiry: data });

        store.emit("backlog_items:show", {
          item_id: enquiry_id,
          item_type: "Sales::Enquiry",
        });
      },
      error: (data) => {
        return toastr.error(
          __guard__(
            data != null ? data.responseJSON : undefined,
            (x) => x.custom_error_message,
          ) || "something went wrong",
        );
      },
    });
  },
);

store.on("enquiry:priority:disable", function (enquiry_id) {
  $.ajax({
    url: `/api/sales/enquiries/${enquiry_id}/disable_priority`,
    type: "PUT",
    dataType: "json",
    contentType: "application/json",
    success: (data) => {
      store.get().set({ enquiry: data });

      store.emit("backlog_items:show", {
        item_id: enquiry_id,
        item_type: "Sales::Enquiry",
      });

      store.emit("backlog_items:index", { filter: "my_tasks" });
    },
    error: (data) => {
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("enquiry:track_call_outcome", function (enquiry_id, call_outcome) {
  const params = {
    call_outcome: call_outcome,
  };

  axios
    .put(`/api/sales/enquiries/${enquiry_id}/track_call_outcome`, params)
    .then(function (response) {
      store.get().set({ enquiry: response.data });
      showMessage("Call outcome added to activity.");
    })
    .catch((error) => handleError(error));
});

store.on(
  "enquiry:update_commission_manager",
  function (enquiry_id, commission_manager_id) {
    const params = {
      commission_manager_id: commission_manager_id,
    };

    axios
      .put(
        `/api/sales/enquiries/${enquiry_id}/update_commission_manager`,
        params,
      )
      .then(function (response) {
        store.get().set({ enquiry: response.data });
        showMessage("Commission re-assigned.");
      })
      .catch((error) => handleError(error));
  },
);

store.on("enquiry:update_manager", function (enquiry_id, manager_id) {
  const params = {
    manager_id: manager_id,
  };

  axios
    .put(`/api/sales/enquiries/${enquiry_id}/update_manager`, params)
    .then(function (response) {
      store.get().set({ enquiry: response.data });
      store.emit("backlog_items:index", { filter: "my_tasks" });
      showMessage("Manager re-assigned.");
    })
    .catch((error) => handleError(error));
});

store.on(
  "enquiry:update_coordinator",
  function (enquiry_id, coordinator_id) {
    const params = {
      coordinator_id: coordinator_id,
    };

    axios
      .put(`/api/sales/enquiries/${enquiry_id}/update_coordinator`, params)
      .then(function (response) {
        store.get().set({ enquiry: response.data });
        showMessage("Acquisitions Coordinator updated.");
      })
      .catch((error) => handleError(error));
  },
);

store.on("enquiry:lookup_ip", function (enquiry_id) {
  axios
    .get(`/api/sales/enquiries/${enquiry_id}/lookup_ip`)
    .then((response) => {
      alert(parseObject(response.data));
    })
    .catch((error) => {
      handleError(error);
    });
});

store.on("enquiry:lookup_score", function (enquiry_id) {
  axios
    .get(`/api/sales/enquiries/${enquiry_id}/lookup_score`)
    .then((response) => {
      alert(parseObject(response.data));
    })
    .catch((error) => {
      handleError(error);
    });
});

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined;
}
